import { getBaseURL } from '@/commons/utils';
let CryptoJS = require('crypto-js');

/**
 * 定义非标准Token对象
 */
const tokenNames = {
    unitoken: getBaseURL('uni')
};

/**
 * 获取Token名称
 * @param {*} url
 */
export const getTokenName = url => {
    let tokenName;
    for (let tknKey in tokenNames) {
        if (url.indexOf(tokenNames[tknKey]) > -1) {
            tokenName = tknKey;
            break;
        }
    }
    return tokenName || 'auth-token';
};

export const encryptNormal = function(data) {
    let k = Object.keys(data).sort();
    let p = k
        .map(function(it) {
            return it + '=' + data[it];
        })
        .join('&');
    let wordArray = CryptoJS.enc.Utf8.parse(p);
    let base64 = CryptoJS.enc.Base64.stringify(wordArray);
    let s = CryptoJS.MD5(base64).toString();
    return s.toUpperCase();
};

export const encryptJson = function(data) {
    let wordArray = CryptoJS.enc.Utf8.parse(data);
    let base64 = CryptoJS.enc.Base64.stringify(wordArray);
    let s = CryptoJS.MD5(base64).toString();
    return s.toUpperCase();
};
